<template>
  <section>
    <v-dialog
      persistent
      v-model="dialog"
      transition="dialog-bottom-transition"
      width="600"
    >
      <v-card>
        <v-form v-model="valid" ref="form" lazy-validation>
          <!-- Cabecera del formulario -->
          <v-card-title class="headline">
            <v-flex xs9> <v-icon>mail</v-icon> NOTIFICACIÓN </v-flex>
            <v-spacer></v-spacer>
            <v-btn icon @click.native="closeDialog()">
              <v-icon>close</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text class="px-3">
            <v-layout row wrap>
              <v-flex xs12 class="text-xs-center">
                <h4 class="blue--text">
                  {{ papeleta.nombres }}
                </h4>
              </v-flex>
              <v-flex xs12 class="layout justify-center pb-4">
                <table class="tabla-faltas " id="tabla-faltas">
                  <tr>
                    <th>Nro papeleta</th>
                    <th>Fecha desde</th>
                    <th>Fecha hasta</th>
                    <th>Dias</th>
                    <th>Tipo</th>
                  </tr>
                  <tr
                    v-for="(papeleta, index) in papeleta.papeletas"
                    :key="index"
                  >
                    <td style="width: 25%;">
                      {{ papeleta.secuencia }}
                    </td>
                    <td style="width: 25%;">
                      {{ $moment(papeleta.fecha_desde).format("DD/MM/YYYY") }}
                    </td>
                    <td style="width: 25%;">
                      {{ $moment(papeleta.fecha_hasta).format("DD/MM/YYYY") }}
                    </td>
                    <td style="width: 25%;">
                      {{ papeleta.total_dias }}
                    </td>
                    <td style="width: 25%;">
                      {{ papeleta.tipo_vacacion }}
                    </td>
                  </tr>
                </table>
              </v-flex>
              <v-flex>
                <v-btn
                  class="p-0 m-0"
                  color="#0085AD"
                  @click="notificarCorreo(papeleta)"
                  :loading="loading"
                  dark
                  block
                  title="Notificar"
                >
                  <v-icon>mail</v-icon>
                  ENVIAR CORREO
                </v-btn>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions> </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </section>
</template>

<script>
export default {
  // Importación de métodos y funciones de un archivo mixin
  mixins: [],
  props: [],
  components: {},
  // Variables iniciales del componente
  data() {
    return {
      dialog: false,
      valid: true,
      user: this.$storage.get("user"),
      loading: false,
      papeleta: {},
      parametros_notificacion: {}
    };
  },
  // Funcionalidades que se ejecutan al montar el componente
  async mounted() {
    // Verificando si el usuario tiene permiso para interactual con el componente
    const rolesPermitidos = [0]; // ID's de roles permitidos
    if (!this.$util.permisoRol(rolesPermitidos)) {
      this.$router.push("/403");
    }
    this.$bus.$on(
      "openDialogNotificacionIndividual",
      (item, parametros_notificacion) => {
        this.papeleta = item;
        this.dialog = true;
        this.parametros_notificacion = parametros_notificacion;
      }
    );
  },
  // Métodos y funciones del componente
  methods: {
    // MEtodo para abrir o cerrar el dialog
    closeDialog() {
      this.papeleta = {};
      this.dialog = this.dialog ? false : true;
    },
    async notificarCorreo(item) {
      this.loading = true;
      // Generamos HTML tabla
      let tabla = this.generaTabla(item.papeletas);
      let mensaje = `
        <h1>NOTIFICACIÓN PAPELETAS DE VACACIÓN PENDIENTES DE PRESENTACIÓN FÍSICA</h1>
        <p>Sr(a).${item.nombres} </p>
        <p>En cumplimiento a Instructivo ASP-B Nro ##.2025 usted debe presentar las siguientes papeletas de vacaciones de manera física en Control de Personal de la Unidad de Recursos Humanos a la brevedad posible:</p>
        ${tabla}
        <br><br>
        Asimismo, se le recomienda cumplir con los plazos y condiciones establecidos en el Instructivo citado con anterioridad.
        El Incumplimiento será sancionado conforme lo establece la normativa vigente.
        <br>
      `;
      let sw_envio = await this.$service.sendEmail({
        correo: item.correo,
        asunto: "NOTIFICACIÓN PRESENTACIÓN DE PAPELETAS FÍSICAS DE VACACIONES",
        mensaje: mensaje.replace(/<[^>]+>/g, ""),
        html: mensaje
      });
      if (sw_envio) {
        // Guardamos historial de notificaciones
        await this.$query.add("historial_notificaciones_papeletas", {
          id_persona: item.id_persona,
          papeletas: item.papeletas
            .map(papeleta => `${papeleta.tipo_vacacion}-${papeleta.secuencia}`)
            .join(";"),
          fecha_inicio: this.parametros_notificacion.fecha_inicio,
          fecha_fin: this.parametros_notificacion.fecha_fin,
          mensaje: mensaje,
          fecha_notificacion: new Date(),
          id_estado: 1,
          _user_created: this.user.id
        });
      }
      // LLamamos a actualizar el historial
      this.$bus.$emit("actualizaHistorialNotificacion");
      this.closeDialog();
      this.loading = false;
    },
    // Metodo para armar tabla de papeletas
    generaTabla(vacaciones) {
      var cadena = "";
      vacaciones.forEach(element => {
        cadena += `
          <tr style="min-width: 100%;text-align: center;">
            <td style="width=16%">${element.secuencia}</td>
            <td style="width=16%">${this.$moment(element.fecha_desde).format(
              "DD/MM/YYYY"
            )}</td>
            <td style="width=16%">${this.$moment(element.fecha_hasta).format(
              "DD/MM/YYYY"
            )}</td>
            <td style="width=16%">${element.total_dias}</td>
            <td style="width=16%">${element.tipo_vacacion}</td>
            
          </tr>
         `;
      });
      var estilo_header = `style="height: 1em !important;color: rgba(2, 96, 202, 0.884);font-weight: bold;font-size: 0.9em;border-bottom: 1px solid rgba(2, 69, 156, 0.274);padding: 0px 0.2em 0px 0.2em !important;"`;
      var tabla = `
        <table style="min-width: 100%;font-family: 'Arial', sans-serif;">
          <tr>
            <th ${estilo_header}> Nro papeleta</th>
            <th ${estilo_header}> Fecha desde</th>
            <th ${estilo_header}> Fecha hasta</th>
            <th ${estilo_header}> Dias</th>
            <th ${estilo_header}> Tipo</th>
          </tr>
          ${cadena}
        </table>
      `;
      return tabla;
    }
  }
};
</script>
<style lang="scss" scoped>
.tabla-faltas {
  min-width: 100%;
  tr {
    min-width: 100%;
    text-align: center;
    th {
      height: 1em !important;
      color: rgba(2, 96, 202, 0.884);
      font-weight: bold;
      font-size: 0.8em;
      border-bottom: 1px solid rgba(2, 69, 156, 0.274);
      padding: 0px 0.2em 0px 0.2em !important;
    }
    td {
      height: 1em !important;
      font-size: 0.8em !important;
      text-align: center;
      padding: 0px 0.2em 0px 0.2em !important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/admin/vacacion_rrhh/components/EnviaCorreoIndividual.vue